import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {InputAdornment} from "@mui/material";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";

export default function ManageCafeOptionItemFormModal({optionItem, handleClose, handleSave, saving, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);
  const [isNew, setIsNew] = useState(!optionItem?.optionGuid);

  const {register, handleSubmit, setValue, control, reset} = useForm({
    values: handleDefaultValues(optionItem)
  });

  const handleModalClose = () => {
    handleClose();
  };

  const handleFormSave = (data) => {
    let o = {...optionItem};
    let d = {...data};
    d.optionGuid = o.optionGuid;
    d.optionGk = o.optionGk;

    if (data?.price > 0) {
      d.price = parseFloat(data.price);
    }
    handleSave(d);
  };

  const [specialInstructions, setSpecialInstructions] = useState(optionItem?.specialInstructions ? optionItem?.specialInstructions : false);
  const [scheduleDate, setScheduleDate] = useState(optionItem?.scheduleDate ? optionItem?.scheduleDate : false);

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'cafeOptionForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Cafe Option</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        {...register('optionName')}
                        autoComplete="off"
                        className="form-control" id="optionName"
                        label="Option Name"
                        placeholder="Enter Option Name"/>
                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>

                    {scheduleDate &&
                      <div>
                        <DesktopDatePicker
                          slotProps={{
                            actionBar: {
                              actions: ['today'],
                            },
                          }}
                          disabled={true}
                          name="startDate"
                          label="Preview"
                          value={dayjs(new Date())}
                          onChange={(e) => {
                          }}
                        />
                      </div>
                    }

                    {specialInstructions &&
                      <div className={'form-group'}>
                        <MDInput type="text"
                                 disabled={true}
                                 {...register('price', {
                                 })}
                                 InputLabelProps={{shrink: true}}
                                 label="Preview"
                                 placeholder="Special Instructions"
                                 className="form-control"
                                 autoComplete="off"
                                 id="specialInstructionsPreview" />

                      </div>
                    }

                    {!scheduleDate && !specialInstructions &&
                      <div className={'form-group'}>
                        <MDInput type="text"
                                 disabled={specialInstructions || scheduleDate}
                                 {...register('price', {
                                   valueAsDouble: true,
                                 })}
                                 onChange={(e) => {
                                   e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                 }}
                                 InputProps={{
                                   startAdornment: <InputAdornment position="start">
                                     <span className={'fa fa-dollar-sign'}></span>
                                   </InputAdornment>
                                 }}
                                 InputLabelProps={{shrink: true}}
                                 label="Price"
                                 defaultValue={"0.00"}
                                 placeholder="Enter Price"
                                 className="form-control"
                                 autoComplete="off"
                                 id="price"/>

                      </div>
                    }
                  </Col>
                </Row>

                <Row>
                  <Col className={'col mt-2'} xs={12}>
                  <span>
                            <label htmlFor="specialInstructions">
                              <input type="checkbox"
                                     {...register('specialInstructions', {
                                       onChange: (e) => {
                                         setSpecialInstructions(e.target.checked);
                                         if (e.target.checked) {
                                           setScheduleDate(false);
                                           reset({
                                             'scheduleDate': false
                                           })
                                         }
                                       }
                                     })}
                                     id="specialInstructions"/>
                              &nbsp;Special Instructions
                            </label>&nbsp;&nbsp;
                    <label htmlFor="scheduleDate">
                                      <input type="checkbox"
                                             {...register('scheduleDate', {
                                               onChange: (e) => {
                                                 setScheduleDate(e.target.checked);
                                                 if (e.target.checked) {
                                                   setSpecialInstructions(false);
                                                   reset({
                                                     'specialInstructions': false
                                                   })
                                                 }
                                               }
                                             })}
                                             id="scheduleDate"/>
                      &nbsp;Schedule Pick-up
                                    </label>
                          </span>
                  </Col>
                </Row>

              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}